/** Institution merge — shared constants. Hardcoded French, like the rest of the app. */

export const MERGE_TIMEOUT_MS = 15 * 60 * 1000;

export const MERGE_STATUS = {
  draft: { label: "Brouillon", color: "default" },
  previewed: { label: "Prévisualisée", color: "blue" },
  applying: { label: "En cours…", color: "processing" },
  applied: { label: "Appliquée", color: "orange" },
  verified: { label: "Vérifiée", color: "cyan" },
  validated: { label: "Validée", color: "green" },
  finalized: { label: "Finalisée", color: "green" },
  restoring: { label: "Restauration…", color: "processing" },
  restored: { label: "Restaurée", color: "purple" },
  failed: { label: "Échec", color: "red" },
};

/** Cluster presets — the client's exact lists. Every institution listed is a source. */
export const MERGE_PRESET_GROUPS = [
  {
    key: "malevoz",
    label: "Malévoz (7 établissements)",
    targetName: "Malévoz",
    configDonorId: "6512b7c1e7861b296d2794bb",
    sourceIds: [
      "6512b7c1e7861b296d2794bb",
      "6512b7c1e7861b296d2794c2",
      "6512b7c1e7861b296d2794c9",
      "6512b7c1e7861b296d2794d0",
      "65167e9def836553def52bbd",
      "651e52e8b2be177a650f7d08",
      "664ca1ab213ae64b4f9e9c80",
    ],
  },
  {
    key: "bex",
    label: "EPS Bex (3 établissements, sans Aigle)",
    targetName: "EPS Bex",
    configDonorId: "6512b7cce7861b296d2797a1",
    sourceIds: [
      "6512b7cce7861b296d2797a1", // EPS BEX / Direction des écoles de Bex
      "6513e59c302005233e30819d", // Collège La Grande Servanne, Bex
      "6512b7cae7861b296d279735", // Direction des Ecoles de Bex — confirmed by the client 2026-09-14
    ],
  },
  {
    key: "sion",
    label: "Écoles de Sion (7 établissements)",
    targetName: "Direction des écoles de Sion",
    configDonorId: "6512b7c8e7861b296d2796cf",
    sourceIds: [
      "6512b7c8e7861b296d2796cf",
      "6512b7cee7861b296d279832",
      "651bdbf0e8c1d32bd5412045",
      "651be37fe8c1d32bd541264e",
      "6523e17bfc2ed47c57ad2387",
      "65255afeaf6cd0203af27de9",
      "655392af70c2255761803b64",
    ],
  },
];

export const CONFIG_LABELS = {
  type: "Type",
  secondName: "Nom secondaire",
  image: "Logo",
  interventionLocation: "Lieu d'intervention",
  mainType: "Domaine",
  groupedBilling: "Facturation groupée",
  restrictionPerApplicant: "Restriction par demandeur",
  readOnlyPrestation: "Restreindre les commandes",
  restrictionFollowPrestation: "Restriction suivi",
  tags: "Tags",
  principal: "Mandant global",
  notification: "Notifications",
  abacusId: "ID Abacus",
  defaultAddress: "Adresse par défaut",
  defaultLocation: "Lieu par défaut",
};

export const QA_CHECKLIST = [
  {
    key: "list",
    label: "Ouvrir la nouvelle institution et sa liste de prestations",
  },
  { key: "pdf", label: "Ouvrir une facture migrée et régénérer son PDF" },
  {
    key: "booking",
    label: "Créer une nouvelle prestation sur la nouvelle institution",
  },
  { key: "login", label: "Ajouter un utilisateur et vérifier sa connexion" },
  {
    key: "addresses",
    label:
      "Vérifier les adresses de facturation, y compris celles partagées avec une autre institution",
  },
  {
    key: "billLink",
    label: "Vérifier qu'une prestation migrée ouvre toujours sa facture",
  },
];

export const fmtDate = d => (d ? new Date(d).toLocaleString("fr-CH") : "—");
export const fmtDay = d => (d ? new Date(d).toLocaleDateString("fr-CH") : "—");
